import { render, staticRenderFns } from "./onventionalSorting.vue?vue&type=template&id=72a0908b&scoped=true"
import script from "./onventionalSorting.vue?vue&type=script&lang=js"
export * from "./onventionalSorting.vue?vue&type=script&lang=js"
import style0 from "./onventionalSorting.vue?vue&type=style&index=0&id=72a0908b&prod&lang=less&scoped=true"
import style1 from "./onventionalSorting.vue?vue&type=style&index=1&id=72a0908b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0908b",
  null
  
)

export default component.exports